import {frequencies, periods, testStatuses, trueFalseValues, weekdays, sorts} from "@/store/dataEntities/data/filters";

export default {
    NEW_TOURS(state) {
      return state.tours
    },
    USERS(state) {
        return state.users
    },
    POSTS(state) {
        return state.posts
    },
    ROLES(state) {
        return state.roles
    },
    OPERATIONS(state) {
        return state.operations
    },
    RIGHTS(state){
        return state.rights
    },
    ADDITIONAL_PROPS(state) {
        return state.additionalProps
    },
    REPORTS(state) {
        return state.reports
    },
    FILTERS(state) {
        return {
            USERS: {
                items: state.users
            },
            TEST_STATUSES: {
                items: testStatuses
            },
            TRUE_OR_FALSE: {
                items: trueFalseValues
            },
            PERIODS: {
                items: periods
            },
            WEEKDAYS: {
                items: weekdays
            },
            FREQUENCIES: {
                items: frequencies
            },
            FINISHED_TESTS: {
                items: state.finishedTests
            },
            NOT_FINISHED_TESTS: {
                items: state.notFinishedTests
            },
            POSTS: {
                items: state.posts
            },
            ADDITIONAL_PROPS: {
                items: state.additionalProps
            },
            SORTS: {
                items: sorts
            },
            GROUPS: {
                items: state.groups
            },
            THEMES: {
                items: state.themes
            }

        }
    }
}